import { render, staticRenderFns } from "./aLink.vue?vue&type=template&id=d51deff0&scoped=true"
import script from "./aLink.vue?vue&type=script&lang=js"
export * from "./aLink.vue?vue&type=script&lang=js"
import style0 from "./aLink.vue?vue&type=style&index=0&id=d51deff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51deff0",
  null
  
)

export default component.exports